import {
  IPendingWithholding,
  IPendingWithholdingCreate,
  PendingWithholdingStatus
} from "@wingspanhq/bookkeeping/dist/lib/interfaces";
import { WSMutationsConfig } from "@ws-react-query";
import bookkeepingService from "../../services/bookkeeping";
import { WSServiceError } from "../../utils/serviceHelper";
import { QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS } from "../banking/queries/useQueryListInternalAccountTransactions";
import { useWSMutation } from "../helpers";
import { QUERY_TAXES_PENDING_WITHHOLDING } from "./keys";

export const useMutationCreatePendingWithholding = (
  config?: WSMutationsConfig<
    IPendingWithholding,
    WSServiceError,
    IPendingWithholdingCreate
  >
) =>
  useWSMutation(
    async (request: IPendingWithholdingCreate) =>
      await bookkeepingService.createPendingWithholding(request),
    {
      awaitDependencies: [QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS],
      ...config
    }
  );

export const useMutationUpdatePendingWithholding = (
  config?: WSMutationsConfig<
    IPendingWithholding,
    WSServiceError,
    { pendingWithholdingId: string; status: PendingWithholdingStatus }
  >
) =>
  useWSMutation(
    async ({
      pendingWithholdingId,
      status
    }: {
      pendingWithholdingId: string;
      status: PendingWithholdingStatus;
    }) =>
      await bookkeepingService.updatePendingWithholding(
        pendingWithholdingId,
        status
      ),
    {
      dependencies: [
        QUERY_TAXES_PENDING_WITHHOLDING,
        QUERY_LIST_INTERNAL_ACCOUNT_TRANSACTIONS
      ],
      ...config
    }
  );
